import { render, staticRenderFns } from "./Product-Management.vue?vue&type=template&id=72b953b4&scoped=true&"
import script from "./Product-Management.vue?vue&type=script&lang=js&"
export * from "./Product-Management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b953b4",
  null
  
)

export default component.exports